const emailRegExpression = '^[a-zA-Z0-9][\\w\\.\\-+]*[a-zA-Z0-9]@[a-zA-Z0-9][\\w\\.\\-]*[a-zA-Z0-9]\\.[a-zA-Z][a-zA-Z\\.]*[a-zA-Z]$';

export function getEmailRegExpression() {
  return emailRegExpression;
}
